import React, { useState, useContext, useEffect } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import * as FaIcons from "react-icons/fa";
import SignaturePad from "./SignaturePad";
import axios from "axios";
import moment from "moment";
import setAuthToken from "../../functions/auth_header";
import leloContext from "../../context/leloreg/leloContext";
import { PDFDocument } from "pdf-lib";
import { BlobServiceClient } from "@azure/storage-blob";
import { getAppUrl } from "../../functions/getEnv";
import ErrorLogger from "../ErrorLogger";
import { toast } from "react-toastify";

const R7MasterAgreement = () => {
  const LeloContext = useContext(leloContext);

  const {
    formData = {},
    fullLeloFormSubmit,
    onFormDataChange,
    submitLeloForm,
    pass: { master },
    sendleloEmail,
  } = LeloContext;

  const appUrl = getAppUrl(import.meta.env.VITE_NODE_ENV);
  const llacApiEndpoint = import.meta.env.VITE_LLAC_API_ENDPOINT;
  const llacApiKey = import.meta.env.VITE_LLAC_API_KEY;
  const blobEndpoint = import.meta.env.VITE_BLOB_ENDPOINT;
  const blobSas = import.meta.env.VITE_BLOB_SAS;
  const blobContainer = import.meta.env.VITE_BLOB_CONTAINER;

  const {
    createdAt,
    charter,
    charter_id,
    hasPreviouslyEnrolled,
    firstName,
    middleName,
    lastName,
    age,
    gender,
    birthDate,
    studentEmail,
    studentPrimaryPhone,
    studentPrimaryPhoneType,
    pgFirstName,
    pgLastName,
    pgRelationshipToStudent,
    pgPrimaryEmail,
    pgPrimaryPhone,
    pgPrimaryPhoneType,
    liveWithPg,
    livingStatus,
    street,
    city,
    state,
    zip,
    country,
    district,
    isMailingAddressTheSame,
    mailingStreet,
    mailingCity,
    mailingState,
    mailingZip,
    gradeLevel,
    courses,
    selectedCourseAgreements = [],
    studentSignature,
    studentName,
    studentSignatureDate,
    parentSignature,
    parentName,
    parentSignatureDate,
    name,
    selectedLearningCenter,
    status,
    understood2 = false,
    sesson_id,
    siteId,
  } = formData;

  const firstName1 = firstName;
  const lastName1 = lastName;
  const formatted = moment().format("MM-DD-YYYY");
  const currentDateTime = new Date().toISOString().slice(0, 16);
  const navigate = useNavigate();
  const location = useLocation();
  const { permalink, _uuid, _id, LeloRegistrationProfile } = location.state || {};
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");
  const [masterAgreementContent, setMasterAgreementContent] = useState("");
  const [FormSubmit, setFormSubmit] = useState(false);
  const [session1, setSession1] = useState("");
  const [res1, setRes] = useState("");
  const [errorMessage, setErrorMessage] = useState('');
  const [displayDate, setDisplayDate] = useState(formatted);
  const [dateTime, setDateTime] = useState(currentDateTime);
  const [submitLoding, setSubmitLoding] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  let formattedBirthDate = "";
  if (birthDate) {
  const [year2, month2, day2] = birthDate.split("-");
  formattedBirthDate = `${month2}-${day2}-${year2}`;
  }

  //Return to Start if formData.Charter is missing

  // useEffect(() => {
  //   if (!charter_id && !isSubmitting ) {
  //     alert("Something went wrong");
      
  //     if (_uuid === undefined) {
  //       history.push(`/forms/${permalink}/${_id}`);
  //     } else {
  //       history.push(`/forms/${permalink}/${_uuid}/${LeloRegistrationProfile}`);
  //     }
  //   }
  // }, [charter_id, history, permalink, LeloRegistrationProfile, _id, _uuid]);
 
  useEffect(() => {
    if (!charter_id && !isSubmitting ) {
      toast.error("Something went wrong");

      if (_uuid === undefined) {
        navigate(`/forms/${permalink}`);
      } else {
        navigate(`/forms/${permalink}/${_uuid}`);
      }
    }
  }, [charter_id, navigate, permalink, LeloRegistrationProfile, _id, _uuid]);
  
const capitalizeWords = (str) => {
    return str.replace(/\b\w/g, char => char.toUpperCase());
  };

 const getLeloSession = async () => {
  try {
    if (localStorage.token) {
      setAuthToken(localStorage.token);
    }

    const response = await axios.get(`${appUrl}/api/sessions/${permalink}`, {
      params: {
        permalink: permalink,
      },
    });
    const sessions = response.data;
   
    if (Array.isArray(sessions) && sessions.length > 0) {
      setSession1(sessions);

      // Find session that matches the profile
      const matchedSession = sessions.find(
        (session) => session._id === sesson_id
      );
      if (matchedSession) {
        const { schoolYearStartDate, schoolYearEndDate } = matchedSession;

        // Format dates safely
        if (schoolYearStartDate && schoolYearEndDate) {
          const [yearStart, monthStart, dayStart] = schoolYearStartDate.split("-");
          const formattedStart = `${monthStart}-${dayStart}-${yearStart}`;

          const [yearEnd, monthEnd, dayEnd] = schoolYearEndDate.split("-");
          const formattedEnd = `${monthEnd}-${dayEnd}-${yearEnd}`;

          setRes(`${formattedStart} to ${formattedEnd}`);
        } else {
          console.warn("Start or end date is missing in the matched session.");
        }
      } else {
        console.warn("No matched session found for the given LeloRegistrationProfile.");
      }
    } else {
      console.error("No sessions found.");
    }
  } catch (error) {
   // console.error("Error retrieving sessions:", error.message);
    ErrorLogger.logError(error.message);
  }
};

  useEffect(() => {
    const handleBeforeUnload = (event) => {
      const message = "Changes you made may not be saved.";
      event.returnValue = message;
    };
    window.addEventListener("beforeunload", handleBeforeUnload);
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);  

  useEffect(() => {
    
      getLeloSession();
    
    if (charter) {
      fetchMasterAgreement();
    }
  }, [charter, permalink]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const newValue = (name === "studentName" || name === "parentName") ? capitalizeWords(value) : value;
    onFormDataChange({
      target: { name, value: newValue },
    });
  };

  const handleStudentSignatureSave = (signatureData) => {
    onFormDataChange({
      target: {
        name: "studentSignature",
        value: signatureData,
      },
    });
  };

  const handleCheckboxChange = (e) => {
    const checked = e.target.checked;
    if (checked) {
      setErrorMessage('');
    }
    onFormDataChange({
      target: { name: "understood2", value: checked },
    });
  };
  
  const handleParentSignatureSave = (signatureData) => {
    onFormDataChange({
      target: {
        name: "parentSignature",
        value: signatureData,
      },
    });
  };

  const masterFilledOut =
    studentSignature !== "" &&
    studentName !== "" &&
    studentSignatureDate !== "" &&
    understood2 !== "" &&
    (pgRelationshipToStudent === "Self 18+" ||
      (parentSignature !== "" &&
        parentName !== "" &&
        parentSignatureDate !== ""));

  // Helper function to get CSS class for form validation
  const getInputClassName = (value) => {
    if (FormSubmit && !value) {
      return "form-field-error";
    }
    return "form-field-default";
  };

  // Helper function for checkbox validation
  const getCheckboxClassName = () => {
    if (FormSubmit && !understood2) {
      return "checkbox-error";
    }
    return "checkbox-default";
  };

  // Helper function for signature pad validation
  const getSignaturePadClassName = (value) => {
    if (FormSubmit && !value) {
      return "signature-pad-error";
    }
    return "signature-pad-default";
  };

  const fetchMasterAgreement = async () => {
    try {
      setLoading(true);
      if (localStorage.token) {
        setAuthToken(localStorage.token);
      }
      const response = await axios.get(
        `${llacApiEndpoint}/api/v1/config/master_agreement_description`,
        {
          params: {
            charter_id: charter_id,
          },
          headers: {
            "x-functions-key":
              llacApiKey,
          },
        }
      );

      const masterAgreementData = response.data;
      const masterAgreementDescription =
        masterAgreementData.data[0].master_agreement_description;
      setMasterAgreementContent(masterAgreementDescription);
    } catch (error) {
      //console.error("Error fetching agreement:", error);
      setError("Error loading the Agreement content.");
    } finally {
      setLoading(false);
    }
  };

  const handleChange1 = (event) => {
    const selectedDate = event.target.value;

    setDisplayDate(moment(selectedDate).format("MM-DD-YYYY")); 
    setDateTime(moment(selectedDate).format("YYYY-MM-DD") + "T" + moment().format("HH:mm"));
  };

  const formatTimestamp = () => {
    const date = new Date();
    const year = String(date.getFullYear()).slice(-2);
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const day = String(date.getDate()).padStart(2, "0");
    const hours = String(date.getHours()).padStart(2, "0");
    const minutes = String(date.getMinutes()).padStart(2, "0");
    return `${year}${month}${day}_${hours}${minutes}`;
  };

  const sanitize = (str) => {
    if (!str) return '';
    return String(str).replace(/[^a-zA-Z0-9]/g, "");
  };
 const fillPdfWithFormData = async (startDateStr, endDateStr) => {
    const pdfUrl = `${blobEndpoint}/${blobContainer}/Master%20Agreement%20PDF%20Template.pdf?${blobSas}`;

    try {
      // Fetch the PDF file
      const existingPdfBytes = await axios.get(pdfUrl, {
        responseType: "arraybuffer",
        withCredentials: false, // Disable credentials for Azure Blob Storage CORS
      });
      const pdfDoc = await PDFDocument.load(existingPdfBytes.data);

      // Get the form fields in the PDF
      const form = pdfDoc.getForm();
      const fields = form.getFields();

      form.getTextField("Charter").setText(charter || "");

      const firstNameField = form.getTextField("Student First Name");
      firstNameField.setText(firstName || "");
      firstNameField.setFontSize(13);

      const lastNameField = form.getTextField("Student Last Name");
      lastNameField.setText(lastName || "");
      lastNameField.setFontSize(13);

      const gradeLevelField = form.getTextField("Gradelevel");
      gradeLevelField.setText(gradeLevel || "");
      gradeLevelField.setFontSize(13);

      const courseField1 = form.getTextField("Course 1");
      courseField1.setText(selectedCourseAgreements[0] || "");
      courseField1.setFontSize(13);

      const courseField2 = form.getTextField("Course 2");
      courseField2.setText(selectedCourseAgreements[1] || "");
      courseField2.setFontSize(13);

      const courseField3 = form.getTextField("Course 3");
      courseField3.setText(selectedCourseAgreements[2] || "");
      courseField3.setFontSize(13);

      const courseField4 = form.getTextField("Course 4");
      courseField4.setText(selectedCourseAgreements[3] || "");
      courseField4.setFontSize(13);

      form.getTextField("Student Signature Name").setText(studentName || "");
      form.getTextField("Parent Signature Name").setText(parentName || "");

      form.getTextField("Student Birth Date").setText(formattedBirthDate || "");
      form.getTextField("Phone 1").setText(studentPrimaryPhone || "");
      form.getTextField("Phone 2").setText(pgPrimaryPhone || "");

      const streetField = form.getTextField("Street Address");
      streetField.setText(street || "");
      streetField.setFontSize(13);

      const cityField = form.getTextField("City");
      cityField.setText(city || "");
      cityField.setFontSize(13);

      const stateField = form.getTextField("State");
      stateField.setText(state || "");
      stateField.setFontSize(13);

      const zipField = form.getTextField("Zip");
      zipField.setText(zip || "");
      zipField.setFontSize(13);

      // Format the date range for this specific PDF
      const [yearStart, monthStart, dayStart] = startDateStr.split("-");
      const formattedStart = `${monthStart}-${dayStart}-${yearStart}`;
      const [yearEnd, monthEnd, dayEnd] = endDateStr.split("-");
      const formattedEnd = `${monthEnd}-${dayEnd}-${yearEnd}`;
      const dateRange = `${formattedStart} to ${formattedEnd}`;

      const dateField = form.getTextField("MA_Dates");
      dateField.setText(dateRange || "");
      dateField.setFontSize(13);

      form.getTextField("Student Signature Date").setText(displayDate || "");

      if (pgRelationshipToStudent !== "Self 18+") {
        form.getTextField("Parent Signature Date").setText(displayDate || "");
      }

      if (studentSignature) {
        const base64Data = studentSignature.replace(
          /^data:image\/png;base64,/,
          ""
        );

        const signatureImageBytes = Uint8Array.from(atob(base64Data), (c) =>
          c.charCodeAt(0)
        );

        const signatureImage = await pdfDoc.embedPng(signatureImageBytes);
        const signatureImageDims = signatureImage.scale(0.5);

        const page = pdfDoc.getPages()[1];

        const xPosition = 70;
        const yPosition = 590;

        const maxWidth = 400;
        const scaledWidth = Math.min(signatureImageDims.width, maxWidth);
        const scaleFactor = scaledWidth / signatureImageDims.width;
        const scaledHeight = signatureImageDims.height * scaleFactor;

        page.drawImage(signatureImage, {
          x: xPosition,
          y: yPosition,
          width: scaledWidth,
          height: scaledHeight,
        });
      }

      if (parentSignature) {
        const base64Data = parentSignature.replace(
          /^data:image\/png;base64,/,
          ""
        );
        const signatureImageBytes = Uint8Array.from(atob(base64Data), (c) =>
          c.charCodeAt(0)
        );

        const signatureImage = await pdfDoc.embedPng(signatureImageBytes);
        const signatureImageDims = signatureImage.scale(0.5);

        const page = pdfDoc.getPages()[1];

        const xPosition = 70;
        const yPosition = 470;

        page.drawImage(signatureImage, {
          x: xPosition,
          y: yPosition,
          width: signatureImageDims.width,
          height: signatureImageDims.height,
        });
      }

      // Save the filled PDF
      const pdfBytesFilled = await pdfDoc.save();

      const blobServiceClient = new BlobServiceClient(`
        ${blobEndpoint}?${blobSas}
      `);

      const containerClient =
        blobServiceClient.getContainerClient(blobContainer);

      // Format start date for filename (MMDDYYYY)
      const startDateForFilename = `${monthStart}${dayStart}${yearStart}`;
      const folderName = sanitize(session1[0].name || '');
      const blobName = `${folderName}/${sanitize(session1[0].name || '')}_${sanitize(lastName || '')}${sanitize(firstName || '')}_${startDateForFilename}_${formatTimestamp()}.pdf`;

      const blockBlobClient = containerClient.getBlockBlobClient(blobName);

      // Upload the filled PDF to Azure Blob Storage
      await blockBlobClient.uploadData(pdfBytesFilled, {
        blobHTTPHeaders: { blobContentType: "application/pdf" },
      });

      const uploadedUrl = blockBlobClient.url.split('?')[0];
      return uploadedUrl;

    } catch (error) {
      console.error("Error filling the PDF or uploading to Azure:", error);
      throw error;
    }
  };
  const validateFormData = (formData) => {
  const errors = [];
  
  // Validate charter
  if (!formData.charter || !formData.charter.trim()) {
    errors.push("Charter is required");
  }
  
  // Validate charter_id
  if (!formData.charter_id || !formData.charter_id.trim()) {
    errors.push("Charter ID is required");
  }
  
  // Validate learning center (check multiple possible field names)
  const learningCenter = formData.selectedLearningCenter || formData.name || formData.learningCenters;
  if (!learningCenter || !learningCenter.trim()) {
    errors.push("Learning Center is required");
  }
  
  // Validate siteId
  if (!formData.siteId || !formData.siteId.trim()) {
    errors.push("Site ID is required");
  }
  
  return errors;
};

// Use this in your form submission (R7MasterAgreement.js)
const handleSubmit = async (e) => {
  e.preventDefault();
  setIsSubmitting(true);
  

  if (submitLoding) return;
  if (masterFilledOut && understood2) {
    setSubmitLoding(true)
    toast.success("Form submitted successfully!")
  }
  else{
    toast.error("Please fill all requried fields")
  }

  const allFormData = {
    charter,
    charter_id,
    hasPreviouslyEnrolled,
    firstName,
    middleName,
    lastName,
    gender,
    age,
    birthDate,
    studentEmail,
    studentPrimaryPhone,
    studentPrimaryPhoneType,
    pgFirstName,
    pgLastName,
    pgRelationshipToStudent,
    pgPrimaryEmail,
    pgPrimaryPhone,
    pgPrimaryPhoneType,
    liveWithPg,
    livingStatus,
    street,
    city,
    state,
    zip,
    country,
    district,
    isMailingAddressTheSame,
    mailingStreet,
    mailingCity,
    mailingState,
    mailingZip,
    gradeLevel,
    courses,
    selectedCourseAgreements,
    studentSignature,
    studentName,
    studentSignatureDate: dateTime,
    parentSignature,
    parentName,
    parentSignatureDate: pgRelationshipToStudent !== "Self 18+" ? dateTime : "",
    name: selectedLearningCenter || name, // Ensure name is set
    selectedLearningCenter: selectedLearningCenter || name, // Ensure this is always set
    permaLink: permalink,
    LeloRegistrationProfile: sesson_id,
    siteId,
    status: "Signed"
  };

  // Validate form data before submission
  const validationErrors = validateFormData(allFormData);
  if (validationErrors.length > 0) {
    setError(`Validation failed: ${validationErrors.join(', ')}`);
    setFormSubmit(true);
    setSubmitLoding(false);
    setIsSubmitting(false);
    return;
  }

  const isValidForm = masterFilledOut && understood2;

  if (!isValidForm) {
    setFormSubmit(true);
    if (!understood2) {
      setErrorMessage('You must understand the terms to proceed.');
    }
    setSubmitLoding(false);
    setIsSubmitting(false);
    return;
  }

  try {
    setFormSubmit(false);

    // Find the matched session to get all start/end dates
    const matchedSession = session1.find(session => session._id === sesson_id);

    if (!matchedSession) {
      throw new Error("No matching session found");
    }

    const { schoolYearStartDate, schoolYearEndDate } = matchedSession;

    // Generate PDFs for all start dates
    const uploadedPdfsArray = [];

    for (let i = 0; i < schoolYearStartDate.length; i++) {
      const startDate = schoolYearStartDate[i].date;
      const endDate = schoolYearEndDate[i].date;

      const uploadedUrl = await fillPdfWithFormData(startDate, endDate);

      if (!uploadedUrl) {
        throw new Error(`Failed to upload PDF for date ${startDate}`);
      }

      // Format start date for filename (MMDDYYYY)
      const [yearStart, monthStart, dayStart] = startDate.split("-");
      const startDateForFilename = `${monthStart}${dayStart}${yearStart}`;
      const fileName = `${sanitize(session1[0]?.permalink)}_${sanitize(lastName)}${sanitize(firstName)}_${startDateForFilename}_${formatTimestamp()}.pdf`;

      uploadedPdfsArray.push({
        url: uploadedUrl,
        fileName: fileName,
        uploadedAt: new Date(),
        startDate: startDate
      });
    }

    // Store all PDFs in uploadedPdfs array
    allFormData.uploadedPdfs = uploadedPdfsArray;

    // Keep first PDF in old format for backward compatibility
    allFormData.uploadedUrl = uploadedPdfsArray[0].url;
    allFormData.fileName = uploadedPdfsArray[0].fileName;
    allFormData._uuid = _uuid;

    if (masterFilledOut) {
      if (_uuid === undefined) {
        const newUuid = await submitLeloForm(allFormData);
        allFormData._uuid = newUuid;
        await sendleloEmail(allFormData);
        navigate("/response-lelo", {
          state: {
            firstName: firstName1,
            lastName: lastName1,
            session: session1,
            permalink,
            charter_id,
            charter,
            selectedLearningCenter: allFormData.selectedLearningCenter,
            selectedCourseAgreements,
            courses,
            name: allFormData.selectedLearningCenter,
            _uuid: newUuid,
            siteId,
            LeloRegistrationProfile: sesson_id
          }
        });
      } else {
        // Ensure siteId is included when updating existing form
        const updatedFormData = {
          ...allFormData,
          siteId: siteId || allFormData.siteId // Use existing siteId if new one is not provided
        };
        await fullLeloFormSubmit(_uuid, updatedFormData);
        await sendleloEmail(updatedFormData);
        navigate("/response-lelo", {
          state: {
            firstName: firstName1,
            lastName: lastName1,
            session: session1,
            permalink,
            charter_id,
            charter,
            selectedLearningCenter: updatedFormData.selectedLearningCenter,
            selectedCourseAgreements,
            courses,
            name: updatedFormData.selectedLearningCenter,
            _uuid,
            siteId: updatedFormData.siteId,
            LeloRegistrationProfile: sesson_id
          }
        });
      }
    }
  } catch (error) {
    console.error("Form submission error:", error);
    setError("Error submitting the form. Please try again.");
  } finally {
    setFormSubmit(false);
    setSubmitLoding(false);
    setIsSubmitting(false);
  }
};
  

 

  return (
    <div className="sub-form">
      <h2>
        Agreement<span>(7/7)</span>
        <hr />
      </h2>
      <div className="item">
        <div className="asterisk-group">
          <h3>
            It is Understood that:
          </h3>
        </div>
      </div>

      {/* Display Master Agreement Content */}
      <div className="agreement-container">
        {loading ? (
          <p>Agreement Loading...</p>
        ) : (
          <div
            className="agreement-content"
            dangerouslySetInnerHTML={{ __html: masterAgreementContent }}
          />
        )}
      </div>

      {error && <p className="error">{error}</p>}

      <div className="item">
        <div className="asterisk-group">
          <div className="checkbox-group">
            <label>
              <input
                type="checkbox"
                checked={!!understood2}
                value={understood2 || ""}
                onChange={handleCheckboxChange}
                className={`checkbox-margin ${getCheckboxClassName()}`}
              />
              I Understand
              <FaIcons.FaAsterisk className="asterisk-icon" />
            </label>
            {errorMessage && <div className="error-message">{errorMessage}</div>}
          </div>
        </div>
      </div>

      {/* <form onSubmit={masterFilledOut && handleSubmit}> */}
      <div className="item">
        <div className="signature-group">
          <h3>
            Student Signature:
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </h3>
          <SignaturePad
            onSave={handleStudentSignatureSave}
            initialValue=""
            name="studentSignature"
            className={getSignaturePadClassName(studentSignature)}
          />
        </div>
        <br />
        <div className="signature-group">
          <h3>
            Type in Student's Full Name: <FaIcons.FaAsterisk className="asterisk-icon" />
          </h3>
          <input
            type="text"
            name="studentName"
            maxLength="50"
            value={studentName}
            onChange={handleChange}
            className={getInputClassName(studentName)}
            placeholder={`${firstName} ${middleName ? middleName + ' ' : ''}${lastName}`}
          />
        </div>

        <div className="signature-group">
          <h3>
            Student Signature Date:
            <FaIcons.FaAsterisk className="asterisk-icon" />
          </h3>

          <input
            type="text"
            value={displayDate}
            disabled // Prevent editing
            className="date-input-disabled"
            onClick={handleChange1}
          />
        </div>
      </div>
      {pgRelationshipToStudent !== "Self 18+" && (
        <>
          <div className="item">
            <div className="signature-group">
              <h3>
                Parent/Guardian Signature:
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </h3>
              <SignaturePad
                onSave={handleParentSignatureSave}
                initialValue=""
                name="parentSignature"
                className={getSignaturePadClassName(parentSignature)}
              />
            </div>
            <br />
            <div className="signature-group">
              <h3>
                Type in Parent/Guardian's Full Name:
                <FaIcons.FaAsterisk className="asterisk-icon" />
              </h3>
              <input
                type="text"
                name="parentName"
                value={parentName}
                maxLength="50"
                onChange={handleChange}
                className={getInputClassName(parentName)}
                placeholder={`${pgFirstName} ${lastName}`}
              />
            </div>

            <div className="signature-group">
              <h3>
                Parent/Guardian Signature Date:
                <FaIcons.FaAsterisk className="asterisk-icon" />

              </h3>
              <input
                type="text"
                value={displayDate}
                disabled // Prevent editing
                onClick={handleChange1}
                className="date-input-disabled"
              />
            </div>
          </div>
        </>
      )}

      <div className="progress-btns">
        <div className="circle-btn" onClick={() => navigate(-1)}>
          <FaIcons.FaChevronLeft
            className="progress-level-btn"
            onClick={() => navigate(-1)}
          />
        </div>
      </div>

      <div className="btn-container submit-container">
        <input
          type="submit"
          value={submitLoding ? "Submitting..." : "Submit"}
          className={`btn btn-l4l-green submit-button ${submitLoding ? 'submit-button-disabled' : ''}`}
          onClick={handleSubmit}
          disabled={submitLoding}
        />
      </div>
      {/* </form> */}
    </div>
  );
};

export default R7MasterAgreement;